'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext } from 'react';
import type { DonationFormConfig } from '@/donationForm/types';
const DonationFormConfigContext = createContext<DonationFormConfig>({} as DonationFormConfig);
export function useDonationFormConfig() {
  const context = useContext(DonationFormConfigContext);
  return context;
}
export function DonationFormConfigProvider(t0) {
  const $ = _c(3);
  const {
    children,
    config
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== config) {
    t1 = <DonationFormConfigContext.Provider value={config}>{children}</DonationFormConfigContext.Provider>;
    $[0] = children;
    $[1] = config;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export default DonationFormConfigContext;